/**
 * Formats an estimated render time for the confirmation dialog.
 *
 * Lived twice: once as a helper in SubmissionPage and once inlined as a nested
 * ternary in VideoPage. They happened to agree, but nothing kept them that way.
 */
export function formatEstimatedDuration(seconds?: number | null): string {
  if (seconds === undefined || seconds === null) return 'Calculating…';
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return remainder === 0 ? `${minutes}m` : `${minutes}m ${remainder}s`;
}
